export const payment = (theme) => ({
    root: {},
    paymentContainer: {
        width: "100%",
    },
    progress: {
        maxWidth: 50,
    },
});

export const paymentList = (theme) => ({
    passwordContainer: {
        marginTop: theme.spacing(1),
    },
    avatar: {
        [theme.breakpoints.down("xs")]: {
            position: "absolute",
            right: 0,
            width: 100,
            height: 100,
        },
    },
    bigAvatar: {
        margin: theme.spacing(2, 2),
        width: 128,
        height: 128,
    },
    summaryContainer: {
        margin: theme.spacing(0),
        [theme.breakpoints.down("xs")]: {
            padding: theme.spacing(1),
        },
    },
    prefixInput: {
        width: "100% !important",
        padding: "14px 55px !important",
    },
    prefixInputContainer: {
        marginTop: 17,
    },
    isDefault: {
        backgroundColor: "#bfbfbf",
    },
});
